import React from 'react'
import Touch from './touch/Touch';

import {Link} from 'react-router-dom'
import pic1 from "../../images/logo.png"
import pic from "../../img/Icon ionic-md-arrow-dropdown.svg"
import pic2 from "../../img/Icon feather-phone-call.png"
import pic3 from "../../img/mail.svg"
import pic4 from "../../img/uptimiseit-icon.svg"
import pic5 from "../../img/facebook.svg"
import pic6 from "../../img/linkedin.svg"
import pic7 from "../../img/twiiter.svg"
import pic8 from "../../img/instagram.svg"
import pic9 from "../../img/whatsapp.svg"
import pic10 from "../../img/youtube.svg"
import pic11 from "../../img/copyright01.png"
import pic12 from "../../img/copyright02.png"





const Footer = () => {
  return (
<>
<section className="same-section contact-section" id="contact-section">
        <div className="circle-inner-parent">
          <span className="circle-inner" />
          <span className="circle-inner" />
          <span className="circle-inner" />
        </div>
        <div className="container">
          <div className="same-heading">
            <span className="text-center">Get In Touch</span>
            <div className="mobiles_head">
              <h4>Request Free Quote</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7">
              <div className="contact_form">
                <form action="#" method="post" onsubmit="return chkEnqForm(0);" encType="multipart/form-data">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>Your Name<span style={{color: 'red'}}>* </span>:</label>
                        <input type="text" className="form-control" required name="txtName" id="txtName" placeholder="Enter Name.." />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>Your Email<span style={{color: 'red'}}>* </span>:</label>
                        <input type="email" name="txtEmail" id="txtEmail" required className="form-control" placeholder="Enter Email.." />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>Country<span style={{color: 'red'}}>* </span>:</label>
                        <select name="txtCountry" id="address-country" required className="form-control">
                          <option value="in" selected>India (भारत)</option><option value="af">Afghanistan (‫افغانستان‬‎)</option><option value="al">Albania (Shqipëri)</option><option value="dz">Algeria (‫الجزائر‬‎)</option><option value="as">American Samoa</option><option value="ad">Andorra</option><option value="ao">Angola</option><option value="ai">Anguilla</option><option value="ag">Antigua and Barbuda</option><option value="ar">Argentina</option><option value="am">Armenia (Հայաստան)</option><option value="aw">Aruba</option><option value="ac">Ascension Island</option><option value="au">Australia</option><option value="at">Austria (Österreich)</option><option value="az">Azerbaijan (Azərbaycan)</option><option value="bs">Bahamas</option><option value="bh">Bahrain (‫البحرين‬‎)</option><option value="bd">Bangladesh (বাংলাদেশ)</option><option value="bb">Barbados</option><option value="by">Belarus (Беларусь)</option><option value="be">Belgium (België)</option><option value="bz">Belize</option><option value="bj">Benin (Bénin)</option><option value="bm">Bermuda</option><option value="bt">Bhutan (འབྲུག)</option><option value="bo">Bolivia</option><option value="ba">Bosnia and Herzegovina (Босна и Херцеговина)</option><option value="bw">Botswana</option><option value="br">Brazil (Brasil)</option><option value="io">British Indian Ocean Territory</option><option value="vg">British Virgin Islands</option><option value="bn">Brunei</option><option value="bg">Bulgaria (България)</option><option value="bf">Burkina Faso</option><option value="bi">Burundi (Uburundi)</option><option value="kh">Cambodia (កម្ពុជា)</option><option value="cm">Cameroon (Cameroun)</option><option value="ca">Canada</option><option value="cv">Cape Verde (Kabu Verdi)</option><option value="bq">Caribbean Netherlands</option><option value="ky">Cayman Islands</option><option value="cf">Central African Republic (République centrafricaine)</option><option value="td">Chad (Tchad)</option><option value="cl">Chile</option><option value="cn">China (中国)</option><option value="cx">Christmas Island</option><option value="cc">Cocos (Keeling) Islands</option><option value="co">Colombia</option><option value="km">Comoros (‫جزر القمر‬‎)</option><option value="cd">Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)</option><option value="cg">Congo (Republic) (Congo-Brazzaville)</option><option value="ck">Cook Islands</option><option value="cr">Costa Rica</option><option value="ci">Côte d’Ivoire</option><option value="hr">Croatia (Hrvatska)</option><option value="cu">Cuba</option><option value="cw">Curaçao</option><option value="cy">Cyprus (Κύπρος)</option><option value="cz">Czech Republic (Česká republika)</option><option value="dk">Denmark (Danmark)</option><option value="dj">Djibouti</option><option value="dm">Dominica</option><option value="do">Dominican Republic (República Dominicana)</option><option value="ec">Ecuador</option><option value="eg">Egypt (‫مصر‬‎)</option><option value="sv">El Salvador</option><option value="gq">Equatorial Guinea (Guinea Ecuatorial)</option><option value="er">Eritrea</option><option value="ee">Estonia (Eesti)</option><option value="sz">Eswatini</option><option value="et">Ethiopia</option><option value="fk">Falkland Islands (Islas Malvinas)</option><option value="fo">Faroe Islands (Føroyar)</option><option value="fj">Fiji</option><option value="fi">Finland (Suomi)</option><option value="fr">France</option><option value="gf">French Guiana (Guyane française)</option><option value="pf">French Polynesia (Polynésie française)</option><option value="ga">Gabon</option><option value="gm">Gambia</option><option value="ge">Georgia (საქართველო)</option><option value="de">Germany (Deutschland)</option><option value="gh">Ghana (Gaana)</option><option value="gi">Gibraltar</option><option value="gr">Greece (Ελλάδα)</option><option value="gl">Greenland (Kalaallit Nunaat)</option><option value="gd">Grenada</option><option value="gp">Guadeloupe</option><option value="gu">Guam</option><option value="gt">Guatemala</option><option value="gg">Guernsey</option><option value="gn">Guinea (Guinée)</option><option value="gw">Guinea-Bissau (Guiné Bissau)</option><option value="gy">Guyana</option><option value="ht">Haiti</option><option value="hn">Honduras</option><option value="hk">Hong Kong (香港)</option><option value="hu">Hungary (Magyarország)</option><option value="is">Iceland (Ísland)</option><option value="in">India (भारत)</option><option value="id">Indonesia</option><option value="ir">Iran (‫ایران‬‎)</option><option value="iq">Iraq (‫العراق‬‎)</option><option value="ie">Ireland</option><option value="im">Isle of Man</option><option value="il">Israel (‫ישראל‬‎)</option><option value="it">Italy (Italia)</option><option value="jm">Jamaica</option><option value="jp">Japan (日本)</option><option value="je">Jersey</option><option value="jo">Jordan (‫الأردن‬‎)</option><option value="kz">Kazakhstan (Казахстан)</option><option value="ke">Kenya</option><option value="ki">Kiribati</option><option value="xk">Kosovo</option><option value="kw">Kuwait (‫الكويت‬‎)</option><option value="kg">Kyrgyzstan (Кыргызстан)</option><option value="la">Laos (ລາວ)</option><option value="lv">Latvia (Latvija)</option><option value="lb">Lebanon (‫لبنان‬‎)</option><option value="ls">Lesotho</option><option value="lr">Liberia</option><option value="ly">Libya (‫ليبيا‬‎)</option><option value="li">Liechtenstein</option><option value="lt">Lithuania (Lietuva)</option><option value="lu">Luxembourg</option><option value="mo">Macau (澳門)</option><option value="mk">Macedonia (FYROM) (Македонија)</option><option value="mg">Madagascar (Madagasikara)</option><option value="mw">Malawi</option><option value="my">Malaysia</option><option value="mv">Maldives</option><option value="ml">Mali</option><option value="mt">Malta</option><option value="mh">Marshall Islands</option><option value="mq">Martinique</option><option value="mr">Mauritania (‫موريتانيا‬‎)</option><option value="mu">Mauritius (Moris)</option><option value="yt">Mayotte</option><option value="mx">Mexico (México)</option><option value="fm">Micronesia</option><option value="md">Moldova (Republica Moldova)</option><option value="mc">Monaco</option><option value="mn">Mongolia (Монгол)</option><option value="me">Montenegro (Crna Gora)</option><option value="ms">Montserrat</option><option value="ma">Morocco (‫المغرب‬‎)</option><option value="mz">Mozambique (Moçambique)</option><option value="mm">Myanmar (Burma) (မြန်မာ)</option><option value="na">Namibia (Namibië)</option><option value="nr">Nauru</option><option value="np">Nepal (नेपाल)</option><option value="nl">Netherlands (Nederland)</option><option value="nc">New Caledonia (Nouvelle-Calédonie)</option><option value="nz">New Zealand</option><option value="ni">Nicaragua</option><option value="ne">Niger (Nijar)</option><option value="ng">Nigeria</option><option value="nu">Niue</option><option value="nf">Norfolk Island</option><option value="kp">North Korea (조선 민주주의 인민 공화국)</option><option value="mp">Northern Mariana Islands</option><option value="no">Norway (Norge)</option><option value="om">Oman (‫عُمان‬‎)</option><option value="pk">Pakistan (‫پاکستان‬‎)</option><option value="pw">Palau</option><option value="ps">Palestine (‫فلسطين‬‎)</option><option value="pa">Panama (Panamá)</option><option value="pg">Papua New Guinea</option><option value="py">Paraguay</option><option value="pe">Peru (Perú)</option><option value="ph">Philippines</option><option value="pl">Poland (Polska)</option><option value="pt">Portugal</option><option value="pr">Puerto Rico</option><option value="qa">Qatar (‫قطر‬‎)</option><option value="re">Réunion (La Réunion)</option><option value="ro">Romania (România)</option><option value="ru">Russia (Россия)</option><option value="rw">Rwanda</option><option value="bl">Saint Barthélemy</option><option value="sh">Saint Helena</option><option value="kn">Saint Kitts and Nevis</option><option value="lc">Saint Lucia</option><option value="mf">Saint Martin (Saint-Martin (partie française))</option><option value="pm">Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)</option><option value="vc">Saint Vincent and the Grenadines</option><option value="ws">Samoa</option><option value="sm">San Marino</option><option value="st">São Tomé and Príncipe (São Tomé e Príncipe)</option><option value="sa">Saudi Arabia (‫المملكة العربية السعودية‬‎)</option><option value="sn">Senegal (Sénégal)</option><option value="rs">Serbia (Србија)</option><option value="sc">Seychelles</option><option value="sl">Sierra Leone</option><option value="sg">Singapore</option><option value="sx">Sint Maarten</option><option value="sk">Slovakia (Slovensko)</option><option value="si">Slovenia (Slovenija)</option><option value="sb">Solomon Islands</option><option value="so">Somalia (Soomaaliya)</option><option value="za">South Africa</option><option value="kr">South Korea (대한민국)</option><option value="ss">South Sudan (‫جنوب السودان‬‎)</option><option value="es">Spain (España)</option><option value="lk">Sri Lanka (ශ්‍රී ලංකාව)</option><option value="sd">Sudan (‫السودان‬‎)</option><option value="sr">Suriname</option><option value="sj">Svalbard and Jan Mayen</option><option value="se">Sweden (Sverige)</option><option value="ch">Switzerland (Schweiz)</option><option value="sy">Syria (‫سوريا‬‎)</option><option value="tw">Taiwan (台灣)</option><option value="tj">Tajikistan</option><option value="tz">Tanzania</option><option value="th">Thailand (ไทย)</option><option value="tl">Timor-Leste</option><option value="tg">Togo</option><option value="tk">Tokelau</option><option value="to">Tonga</option><option value="tt">Trinidad and Tobago</option><option value="tn">Tunisia (‫تونس‬‎)</option><option value="tr">Turkey (Türkiye)</option><option value="tm">Turkmenistan</option><option value="tc">Turks and Caicos Islands</option><option value="tv">Tuvalu</option><option value="vi">U.S. Virgin Islands</option><option value="ug">Uganda</option><option value="ua">Ukraine (Україна)</option><option value="ae">United Arab Emirates (‫الإمارات العربية المتحدة‬‎)</option><option value="gb">United Kingdom</option><option value="us">United States</option><option value="uy">Uruguay</option><option value="uz">Uzbekistan (Oʻzbekiston)</option><option value="vu">Vanuatu</option><option value="va">Vatican City (Città del Vaticano)</option><option value="ve">Venezuela</option><option value="vn">Vietnam (Việt Nam)</option><option value="wf">Wallis and Futuna (Wallis-et-Futuna)</option><option value="eh">Western Sahara (‫الصحراء الغربية‬‎)</option><option value="ye">Yemen (‫اليمن‬‎)</option><option value="zm">Zambia</option><option value="zw">Zimbabwe</option><option value="ax">Åland Islands</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group input-group">
                        <label>Your Phone Number<span style={{color: 'red'}}>* </span>:</label>
                        <div className="country-select-parent">
                          <select name="code" className="ptest">
                            <Touch />
                          </select>
                          <input className="form-control phone" maxLength={15} onkeyup="return formatPhone(this)" max={15} min={15} name="txtPhone" required type="tel" id="phone" placeholder="Enter Phone No..." />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>I am Interested in<span style={{color: 'red'}}>* </span>:</label>
                        <div className="form-dropdown">
                          <img src={pic} alt="uptimise it" />
                          <select name="interested" id="interested" className="form-control">
                            <option value="no_option_choose">--Select--</option>
                            <option value="Enterprise Software Solutions">
                              Enterprise Software Solutions
                            </option>
                            <option value="Creating a Mobile App">
                              Creating a Mobile App
                            </option>
                            <option value="Web Development">
                              Web Development
                            </option>
                            <option value="Dedicated Team Service">
                              Dedicated Team Service
                            </option>
                            <option value="IT Consulting Services">
                              IT Consulting Services
                            </option>
                            <option value="Enhancing an Existing Product">
                              Enhancing an Existing Product
                            </option>
                            <option value="Partnership Opportunities">
                              Partnership Opportunities
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>Upload File:</label>
                        <div className="file-upload-wrapper" data-text="Select your file!">
                          <input name="helpFile" type="file" className="form-control" label="uptimiseit" />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="exampleFormControlTextarea1">Your Message:</label>
                        <textarea name="txtMsg" placeholder="Enter Message.." className="form-control" id="textMessage" rows={3} defaultValue={""}  />
                      </div>
                    </div>
                  </div>
                  <div className="request-popup-btn">
                    <div className="captcha-parent">
                      <div id="google_recaptcha" style={{transform: 'scale(0.77)', WebkitTransform: 'scale(0.77)', transformOrigin: '0 0', WebkitTransformOrigin: '0 0'}} data-theme="light" />
                    </div>
                    <div className="contact-btn">
                      <input type="hidden" name="form_submit" defaultValue="true" />
                      <input type="hidden" name="how_to_find" id="how_to_find" defaultValue="true" />
                      <input type="hidden" name="start" id="start" defaultValue="true" />
                      <input type="submit" name="btnSubmit" className="btn btn-primaryx" defaultValue="Send Message" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="contact_us">
                <h3>Contact Us:</h3>
                <div className="contact_first">
                  <div className="contact_first_img">
                    <Link to="https://www.google.com/maps/place/Jaipur,+Rajasthan/@26.8854479,75.6504695,11z/data=!3m1!4b1!4m5!3m4!1s0x396c4adf4c57e281:0xce1c63a0cf22e09!8m2!3d26.9124336!4d75.7872709" target="_blank">
                      <img src="img/map.png" alt="uptimise it" style={{height: '30px', width: '30px'}} />
                    </Link>
                  </div>
                  <div className="contact_first_para">
                    <p>
                     Jaipur
                    </p>
                  </div>
                  <div className="contact_form_icons">
                    <div className="contact_icons">
                      <img src={pic2} alt="uptimiseit" />
                    </div>
                    <div className="contact_phone">
                      <h3><Link to="tel:+91 141 358 2178">+91 141 358 2178</Link></h3>
                    </div>
                  </div>
                </div>
                <div className="contact_first">
                  <div className="contact_first_img">
                    <Link to="https://www.google.com/maps/place/Mumbai,+Maharashtra/@19.0825223,72.7410971,11z/data=!3m1!4b1!4m5!3m4!1s0x3be7c6306644edc1:0x5da4ed8f8d648c69!8m2!3d19.0759837!4d72.8776559" target="_blank">
                      <img src="img/map.png" alt="uptimise it" style={{height: '30px', width: '30px'}} />
                    </Link>
                  </div>
                  <div className="contact_first_para">
                    <p>Mumbai</p>
                  </div>
                  <div className="contact_form_icons">
                    <div className="contact_icons">
                      <img src={pic2}alt="uptimise it" />
                    </div>
                    <div className="contact_phone">
                      <h3><Link to="tel:+917020134662">+917020134662</Link></h3>
                    </div>
                  </div>
                </div>
                <div className="contact_first">
                  <div className="contact_first_img">
                    <Link to="https://www.google.com/maps/place/Pune,+Maharashtra/@18.5248904,73.7228783,11z/data=!3m1!4b1!4m5!3m4!1s0x3bc2bf2e67461101:0x828d43bf9d9ee343!8m2!3d18.5204303!4d73.8567437" target="_blank">
                      <img src="img/map.png" alt="uptimise it" style={{height: '30px', width: '30px'}} />
                    </Link>
                  </div>
                  <div className="contact_first_para">
                    <p>Pune</p>
                  </div>
                  <div className="contact_form_icons">
                    <div className="contact_icons">
                      <img src={pic2} alt="uptimise it" />
                    </div>
                    <div className="contact_phone">
                      <h3><Link to="tel:+917020134662">+917020134662</Link></h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

        
      <footer>
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="footer-logo-parent">
                  <div className="footer-logo">
                    <Link to="/"><img src={pic1} alt="logop" /></Link>
                  </div>
                  <p>
                    Uptimise It is a leading mobile app development company with a
                    range of renowned mobile app development services and proven
                    work.
                  </p>
                </div>
              </div>
              <div className="col">
                <div className="footer-menu">
                  <h3>Company</h3>
                  <ul>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/ourwork">Portfolio</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-menu">
                  <h3>Services</h3>
                  <ul>
                    <li>
                      <Link to="/android-app-development">Android App Development</Link>
                    </li>
                    <li>
                      <Link to="/ios-app-development">iPhone App Development</Link>
                    </li>
                    <li>
                      <Link to="/ui-ux-design-development">UI/UX Design</Link>
                    </li>
                    <li>
                      <Link to="/maintenance-support">Maintenance &amp; Support</Link>
                    </li>
                    <li>
                      <Link to="/web-development-company">Custom Web Development</Link>
                    </li>
                    <li>
                      <Link to="/saas-and-enterprise-solutions">SAAS &amp; Enterprise App Development</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="footer-menu">
                  <h3>Industries</h3>
                  <ul>
                    <li>
                      <Link to="/logistics-app-development">Logistics App</Link>
                    </li>
                    <li>
                      <Link to="/loan-lending-app-development">Loan Lending App</Link>
                    </li>
                    <li>
                      <Link to="/mobile-banking-app-development">Banking, Finance &amp; Insurance</Link>
                    </li>
                    <li>
                      <Link to="/artificial-intelligence-application-development">AI App Development</Link>
                    </li>
                    <li>
                      <Link to="/cryptocurrency-app-development">Cryptocurrency App</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-middle">
          <div className="footer-inner-parent">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="footer-inner-content">
                  <p>
                    4.9 / 5.0 by 200+ customers for 250+ Web and Mobile App
                    development projects.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="footer-inner-social">
                  <ul>
                    <li>
                      <div className="footer-social-icon">
                        <img src={pic3} alt="uptimise it" />
                      </div>
                      <div className="footer-email">
                        <Link to="mailto:sales@uptimiseit.com">sales@uptimiseit.com</Link>
                      </div>
                    </li>
                    <li>
                      <div className="footer-social-icon">
                        <img src={pic4} alt="uptimise it" />
                      </div>
                      <div className="footer-email">
                        <a style={{color: 'white'}}>Uptimise IT</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="bottom-social">
              <ul>
                <li>
                  <a href="https://www.facebook.com/uptimiseit" target="_blank">
                    <img src={pic5} alt="uptimise it" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/uptimise-it/" target="_blank">
                    <img src={pic6} alt="uptimise it" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/uptimise-it/">
                    <img src={pic7} alt="uptimise it" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/uptimiseit/">
                    <img src={pic8} alt="uptimise it" />
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/917020134662">
                    <img src={pic9} alt="uptimise it" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src={pic10} alt="uptimise it" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="copyright-parent">
              <p>
                Copyright <Link to="index">Uptimise It</Link> All Right Reserved.   
              </p>
              <div className="copyright-img">
                <img src={pic11} alt="uptimise it" />
                <img src={pic12} alt="uptimise it" />
              </div>
            </div>
          </div>
        </div>
      
      </footer>
      </>
    );
    }


export default Footer;
